<button class="icon-left" mat-icon-button [matMenuTriggerFor]="listFilterMenu" aria-label="Filter">
    <mat-icon [ngClass]="{'material-icons-outlined' : !hasFilterSelected()}">filter_alt</mat-icon>
</button>
<mat-menu #listFilterMenu="matMenu">
    <div class="listFilterMenu" (click)="$event.stopPropagation()">
        <div>
            <button class="clear-button" mat-icon-button (click)="clearFilters()">
                <div class="icon-container">
                    <mat-icon>block</mat-icon>
                </div>
                <span class="text-container">Clear filter</span>
            </button>
        </div>
        <div *ngFor="let item of itemsSource" class="small-margins medium-margin-top">
            <mat-checkbox color="primary" (change)="updateFilter(item, $event.checked)">{{item.name}}</mat-checkbox>
        </div>
    </div>
</mat-menu>